import HeaderLeft from '../../../components/Header/HeaderLeft'

export default function HealthSectionHeader() {
  
  return (
<>

    <HeaderLeft
        
      headerleft = {'Manage your Health - ahead of symptoms'}

    />
      
   

</>
   )
}